/* eslint-disable import/order */
// redux ломается если что-то импортировано не так как он хочет
import React from 'react';
// при переезде на Vite стала падать ошибка https://github.com/TanStack/table/issues/3297, фикснулось этой библиотекой
import 'regenerator-runtime/runtime.js';
import { i18nReady } from '@vlapps/clementine/src/app/translations/i18n';

import '@vlabs/uikit/assets/css/uikit.css';
import { createBrowserHistory } from 'history';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

import { store } from '@vlapps/clementine/src/app/store';
import { routes } from '@vlapps/clementine/src/app/navigation/routes';
import { setRoutes } from '@vlabs/shared/navigation/routes';
import { ClementineApp } from '@vlapps/clementine/src/app/ClementineApp';
import { initApp } from './app/store/appSlice';
import * as serviceWorker from './serviceWorker';
import { registerErrorHandlers } from '@vlabs/shared/utils/error-handler';
import '@vlapps/clementine/src/api/index';
import 'react-toastify/dist/ReactToastify.css';
import '@vlapps/clementine/src/app/styles/index.sass';
import '@vlapps/clementine/src/app/styles/toasts.sass';
import 'video.js/dist/video-js.css';

setRoutes(routes);
registerErrorHandlers();

store.dispatch(initApp);

const history = createBrowserHistory();

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

// Ждём загрузки переводов (динамический import локалей по VITE_LOCALES) перед первым рендером.
void i18nReady.then(() => {
  root.render(
    <React.StrictMode>
      <Router history={history}>
        <Provider store={store}>
          <ClementineApp />
          <ToastContainer
            hideProgressBar
            position={toast.POSITION.TOP_LEFT}
          />
        </Provider>
      </Router>
    </React.StrictMode>,
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// expose store when run in Cypress
// FIXME: use only in test environment
if (window.Cypress) {
  window.cprs = {
    store,
    history,
  };
}
